import { paperStyles } from '@festina-life/ui/libs'
import { Stack } from '@festina-life/ui/structure'
import cx from 'classnames'
import type { PropsWithChildren } from 'react'

type Props = PropsWithChildren<{
  className?: string
}>

/**
 * The bar shown at the top of an operation viewer, hosting the controls acting on the
 * operation in scope.
 */
export const OperationViewerTopBar = ({ children, className }: Props) => (
  <Stack
    padding="normal"
    className={cx(
      'items-center max-h-(--topBar-height) h-(--topBar-height) pl-6',
      paperStyles({ isFaded: true, borders: ['bottom'] }),
      className,
    )}
  >
    {children}
  </Stack>
)
